import timelineElements from "./timelineevents";

import { ReactComponent as WorkIcon } from "./work.svg";
import { ReactComponent as SchoolIcon } from "./school.svg";
import { ReactComponent as StarIcon } from "./star.svg";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";

import React, { Component } from "react";

class Education extends Component {
  render() {
    let workIconStyles = { background: "#06D6A0" };
    let schoolIconStyles = { background: "#f9c74f" };

    return (
      <div className="education-section">
        <h1
          data-aos="fade-up"
          data-aos-anchor=".about-section"
          data-aos-anchor-placement="bottom-center"
          data-aos-duration="1000"
          className="heading"
        >
          Education
        </h1>
        <VerticalTimeline>
          {timelineElements.map((element) => {
            let isWorkIcon = element.icon === "work";
            let showButton =
              element.buttonText !== undefined &&
              element.buttonText !== null &&
              element.buttonText !== "";

            showButton = false;
            return (
              <VerticalTimelineElement
                key={element.key}
                date={element.date}
                contentStyle={{
                  background: "#325774",
                  color: "white",
                  borderRadius: "10px",
                  fontSize: "2rem",
                  fontFamily: "sans-serif",
                }}
                dateClassName="mydate"
                iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
                icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title">
                  {element.title}
                </h3>
                <h5 className="vertical-timeline-element-subtitle">
                  {element.location}
                </h5>
                <p id="description">{element.description}</p>
                {showButton && (
                  <a
                    className={`button ${
                      isWorkIcon ? "workButton" : "schoolButton"
                    }`}
                    href="/"
                  >
                    {element.buttonText}
                  </a>
                )}
              </VerticalTimelineElement>
            );
          })}
          <VerticalTimelineElement
            iconStyle={workIconStyles}
            icon={<StarIcon />}
          ></VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    );
  }
}

export default Education;
